import { Button, DataHeader, DataSource, Layout, Table, Textbox } from "@mcleod/components";

export abstract class AutogenLayoutPayee401kRates extends Layout {
    buttonAddPayRate: Button;
    buttonCollapseAll: Button;
    buttonExpandAll: Button;
    dataheaderPayee401kRates: DataHeader;
    sourcePayee401kRate: DataSource;
    sourcePayee401krateHdr: DataSource;
    tablePayee401kRate: Table;
    textboxId: Textbox;
}
